import * as React from "react";
import PropTypes from "prop-types";
import {useDemoData} from "@mui/x-data-grid-generator";
import {createTheme, styled} from "@mui/material/styles";
import {makeStyles} from "@material-ui/core/styles";
import {PuiSection, PuiTextField} from "@portnet/ui";
import SearchIcon from '@mui/icons-material/Search';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import {connect} from "react-redux";
import {InputAdornment, tableCellClasses} from "@mui/material";
import Grid from "@mui/material/Grid";
import NtnRow from "./NtnRow";
import ExportExcel from "../../../../common/components/ExportExcel";

const defaultTheme = createTheme();

function Item(props) {
    return null;
}

Item.propTypes = {children: PropTypes.node};

const useStyles = makeStyles((theme) => ({
    tableCellStyle: {
        justifyContent: "center",
        textAlign: "center",
    },
    table: {
        marginTop: "10px",
        marginBottom: "30px",
    },
}));

const NtnResultForm = (props) => {
    const style = useStyles();
    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#c6c9ca',
            color: '#232f66',
            fontSize: 12,
            fontWeight: 600,
            height: 40,
            minHeight: 40,
            padding:0,
            textAlign: 'left'
        },
        [`&.${tableCellClasses.root}`]: {
            fontSize: 12,
            padding: 0,
            textAlign: 'left'
        },
    }));

    const {data} = useDemoData({
        dataSet: "Commodity",
        rowLength: 50,
        maxColumns: 6,
    });

    const [searchText, setSearchText] = React.useState("");
    const [rows, setRows] = React.useState(data.rows);

    React.useEffect(() => {
        setRows(props.shipments ? props.shipments : []);
    }, [props.shipments]);

    const requestSearch = (searchText) => {
        console.log(searchText)
        const filteredRows = props.shipments.filter((row) => {
            return (
                row.idEquipment?.toLowerCase().includes(searchText.toLowerCase()) ||
                row.port?.toLowerCase().includes(searchText.toLowerCase()) ||
                row.customsStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
                row.gateInDateTime?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
        setRows(filteredRows);
    };

    const cancelSearch = () => {
        setSearchText("");
        requestSearch(searchText);
    };

        return (
            <PuiSection title="Résultat de recherche" sx={{marginTop: 2}} >
                <Grid container spacing={5}>
                    <Grid item xs={12} md={5}>
                        <PuiTextField
                            formik={false}
                            placeholder={"Filtrer"}
                            onChange={(searchText) => requestSearch(searchText.target.value)}
                            onCancelSearch={() => cancelSearch()}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                            <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </Grid>
                    <Grid xs={12} md={4}></Grid>
                    <Grid item xs={3} textAlign={"right"}>
                        <ExportExcel ExcelData={rows} fileName={"liste des conteneurs"}/>
                    </Grid>
                </Grid>
                <TableContainer component={Paper} style={{overflowX : "clip"}}>
                    <Table
                        stickyHeader
                        aria-label="collapsible table"
                        className={style.table}
                    >
                        <TableHead className="Gu-MuiTableCell-head">
                            <TableRow className="Gu-MuiTableCell-root">
                                <StyledTableCell className={style.tableCellStyle}/>
                                <StyledTableCell className={style.tableCellStyle}>
                                    Numéro de conteneur
                                </StyledTableCell>
                                <StyledTableCell className={style.tableCellStyle}>
                                    Port
                                </StyledTableCell>
                                <StyledTableCell className={style.tableCellStyle}>
                                    Statut douanier
                                </StyledTableCell>
                                <StyledTableCell className={style.tableCellStyle}>
                                    ETA - ETD
                                </StyledTableCell>
                                <StyledTableCell className={style.tableCellStyle}>
                                    Date MAJ
                                </StyledTableCell>
                                <StyledTableCell className={style.tableCellStyle}>

                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <NtnRow key={row.name} row={row}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </PuiSection>
        );

};

const mapStateToProps = (state) => {
    return {
        shipmentByUser: state.ShipmentByUserReducer,
        shipment: state.ShipmentReducer,
    };
};

export default connect(mapStateToProps, null)(NtnResultForm);
